import type { TNetworkError } from '@/services/errors';
import type { TEmailSendBodyDTO, TEmailSendResponseDTO } from './emailSends.dto';

import { BaseService } from '@/services/api';
import { errorUtils } from '@/services/errors';
import { withSessionHeaders } from '@/services/supabase';

import type {
  TEmailSendResult,
  TInviteEmailPayload,
  TMemberEmailPayload,
} from './emailSends.types';

import { EMAIL_SEND_PATH, INVITE_PURPOSE } from './emailSends.fields';
import { toEmailSendResult } from './emailSends.adapters';

class EmailSendsService extends BaseService {
  protected readonly serviceName = 'emailSendsService';

  public sendInviteEmail(payload: TInviteEmailPayload): Promise<TEmailSendResult | TNetworkError> {
    return this.sendEmail(
      { purpose: INVITE_PURPOSE, request_id: payload.requestID, link: payload.link },
      'sendInviteEmail',
    );
  }

  public sendMemberEmail(payload: TMemberEmailPayload): Promise<TEmailSendResult | TNetworkError> {
    return this.sendEmail(
      { purpose: payload.purpose, member_id: payload.memberID },
      'sendMemberEmail',
    );
  }

  private async sendEmail(body: TEmailSendBodyDTO, where: string): Promise<TEmailSendResult | TNetworkError> {
    const response = await this.post<TEmailSendResponseDTO, TEmailSendBodyDTO>(
      EMAIL_SEND_PATH,
      body,
      { where, headers: await withSessionHeaders() },
    );

    if (errorUtils.isNetworkError(response)) {
      return response;
    }

    return toEmailSendResult(response);
  }
}

const emailSendsService = new EmailSendsService();

export {
  emailSendsService,
};
